import { ACTIONS } from '../action/actionTypes'

const initialState = {
  close: () => {}
};

export const navbar = ( state = initialState, action ) => {
  switch ( action.type ) {
    case ACTIONS.SET_CLOSE_NAVBAR:
      return { ...state, close: action.close };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducer/navbar_reducer.js